import { Link, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSesion } from "../sesion";

const NAVEGACION = [
  { a: "/", texto: "Tablero" },
  { a: "/clientes", texto: "Clientes" },
  { a: "/servicios", texto: "Servicios" },
  { a: "/proyectos", texto: "Proyectos" },
  { a: "/cotizaciones", texto: "Cotizaciones" },
  { a: "/facturas", texto: "Facturas" },
  { a: "/pagos", texto: "Pagos" },
  { a: "/dominios", texto: "Dominios" },
] as const;

export function Raiz() {
  const { sesion, cargando, salir } = useSesion();
  const navegar = useNavigate();
  const ruta = useRouterState({ select: (s) => s.location.pathname });
  const esLogin = ruta === "/login";

  useEffect(() => {
    if (!cargando && !sesion && !esLogin) void navegar({ to: "/login" });
  }, [cargando, sesion, esLogin, navegar]);

  if (cargando) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
        Cargando…
      </div>
    );
  }

  if (esLogin || !sesion) return <Outlet />;

  return (
    <div className="min-h-screen">
      <header className="border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
        <div className="mx-auto flex max-w-6xl items-center gap-6 px-4 py-3">
          <img
            src="/logo-uirtus.png"
            alt="Uirtus"
            className="h-5 w-auto dark:brightness-0 dark:invert"
          />

          <nav className="flex flex-1 gap-1">
            {NAVEGACION.map((item) => (
              <Link
                key={item.a}
                to={item.a}
                className="rounded-md px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
                activeProps={{
                  className:
                    "rounded-md px-3 py-1.5 text-sm font-medium bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-white",
                }}
                activeOptions={{ exact: item.a === "/" }}
              >
                {item.texto}
              </Link>
            ))}
          </nav>

          <button
            onClick={() => void salir()}
            className="text-sm text-slate-500 hover:text-slate-900 dark:hover:text-white"
          >
            Salir
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
